<template>
  <div class="animated fadeIn">
    <b-container fluid class="p-0">
      <b-row>
        <b-col cols="12" sm="6" md="3">
          <b-card
            class="cursor-pointer"
            bg-variant="primary"
            :class="ReportType === 'VISITOR' ? 'shadow-lg' : ''"
            @click="changeChartByReportType('VISITOR')"
          >
            <b-card-text>
              <p class="mb-0">Users</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-card
            class="cursor-pointer tax-card"
            :class="ReportType === 'MENU' ? 'shadow-lg' : ''"
            @click="changeChartByReportType('MENU')"
          >
            <b-card-text>
              <p class="mb-0">Photos Seen</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-card
            class="cursor-pointer tip-card"
            :class="ReportType === 'DAY' ? 'shadow-lg' : ''"
            @click="changeChartByReportType('DAY')"
          >
            <b-card-text>
              <p class="mb-0">Days ON</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <b-card
            class="cursor-pointer restaurant-total-card"
            :class="ReportType === 'HOUR' ? 'shadow-lg' : ''"
            @click="changeChartByReportType('HOUR')"
          >
            <b-card-text>
              <p class="mb-0">Hours ON</p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card no-body>
            <b-card-header>
              <b-container class="px-0" fluid>
                <b-row class="align-items-center justify-content-between">
                  <b-col cols="12" lg="9" class="mb-3 mb-lg-0">
                    <b-button-group v-if="filter.ReportType === 'VISITOR' || filter.ReportType === 'MENU'" size="md">
                      <b-button
                        @click="changeChartByItem('Food')"
                        :class="filter.ItemType === 'Food' ? 'activeBtn' : 'deactiveBtn'"
                        >Food</b-button
                      >
                      <b-button
                        @click="changeChartByItem('Drink')"
                        :class="filter.ItemType === 'Drink' ? 'activeBtn' : 'deactiveBtn'"
                        >Drink</b-button
                      >
                    </b-button-group>
                  </b-col>
                  <b-col cols="12" lg="3" class="d-flex flex-row justify-content-end">
                    <b-button-group size="md">
                      <b-button
                        :class="filter.Passed_Date === 12 ? 'activeBtn' : 'deactiveBtn'"
                        @click="changeChartByPassDate(12)"
                        >Last 12 Months</b-button
                      >
                      <b-button v-if="filter.ReportType != 'MENU' && filter.ReportType != 'VISITOR'  " :class="filter.Passed_Date === 7 ? 'activeBtn' : 'deactiveBtn'" @click="changeChartByPassDate(7)"
                        >Last 7 Days</b-button
                      >
                    </b-button-group>
                    <!-- <b-button-group size="md">
                      <b-button class="activeBtn">Last 7 Days</b-button>
                    </b-button-group> -->
                  </b-col>
                </b-row>
              </b-container>
            </b-card-header>
            <b-card-body>
              <div class="w-100 text-center py-2">
                <span class="text-center">
                  {{ title }}
                </span>
              </div>
              <BarChart v-if="render" legends="" :series="series" prefixLabel="" :categories="categories" :titleChart="''" />
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'
import BarChart from './barChart'
export default {
  name: 'Dashboard',
  components: {BarChart},
  component: {
    BarChart
  },
  mounted() {
    moment.locale('en')
  },
  watch: {
    '$store.state.selectedRestaurantId': {
      handler: function(newVal) {
        //View charts of selected restaurants based on 4 parameters
        if (newVal !== null) {
          this.getChart()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      Passed_Date: 7,
      ReportType: 'SUBTOTAL',
      series: [],
      categories: [],
      title: 'Sales',
      render: false,
      stats: [],
      filter: {
        ReportType: 'VISITOR',
        DeviceType: -15,
        ItemType: 'Food',
        Passed_Date: 12
      },
      categories: []
    }
  },
  metaInfo() {
    return {
      title: 'Menu displays'
    }
  },
  methods: {
    changeChartByReportType(ReportType) {
      this.filter.ReportType = ReportType
      if(ReportType === "VISITOR" || ReportType === "MENU")
        return this.changeChartByPassDate(12)//if left in 7 days switch since btn is dsbled
      this.getChart()
    },
    changeChartByItem(ItemType) {
      this.filter.ItemType = ItemType
      this.getChart()
    },
    changeChartByPassDate(Passed_Date) {
      this.filter.Passed_Date = Passed_Date
      this.getChart()
    },

    getChart() {
      const filter = {...this.filter}
      filter.RestaurantID = this.$store.state.selectedRestaurantId
      filter.UserID = localStorage.getItem('userID')
      this.render = false
      this.series = []
      this.$api.getRestaurant.GetRestaurantKioskStats1(filter).then(res => {
        if (res.success) {
          let data = []
          const result = res.results.Stats2[0]
          this.title = this.setName(filter.ReportType) + result.Total
          if (this.filter.Passed_Date === 12) {
            for (let i = 12; i >= 0; i--) {
              data.push(result[`Total${i}`])
            }
            this.categories = [
              moment()
                .subtract(12, 'month')
                .format('MMM Y'),
              moment()
                .subtract(11, 'month')
                .format('MMM Y'),
              moment()
                .subtract(10, 'month')
                .format('MMM Y'),
              moment()
                .subtract(9, 'month')
                .format('MMM Y'),
              moment()
                .subtract(8, 'month')
                .format('MMM Y'),
              moment()
                .subtract(7, 'month')
                .format('MMM Y'),
              moment()
                .subtract(6, 'month')
                .format('MMM Y'),
              moment()
                .subtract(5, 'month')
                .format('MMM Y'),
              moment()
                .subtract(4, 'month')
                .format('MMM Y'),
              moment()
                .subtract(3, 'month')
                .format('MMM Y'),
              moment()
                .subtract(2, 'month')
                .format('MMM Y'),
              moment()
                .subtract(1, 'month')
                .format('MMM Y'),
              moment().format('MMM Y')
            ]
          } else {
            this.categories = [`Total 7-Day`]
            data.push(result.Total)
          }

          this.series.push({
            name: this.setNameChart(filter.ReportType),
            color: this.setColorBars(filter.ReportType),
            data
          })
          this.render = true
        } else {
          this.$showError(res.message)
        }
      })
    },
    setColorBars(reportType) {
      if (reportType === 'VISITOR') {
        return '#20a8d8'
      } else if (reportType === 'MENU') {
        return 'rgb(64,0,64)'
      } else if (reportType === 'DAY') {
        return 'rgb(185,122,87)'
      } else {
        return '#66bb6a'
      }
    },
    setName(reportType) {
      const passedDay = this.filter.Passed_Date
      const prefix = passedDay === 12 ? 'Total 12-Month' : 'Total 7-Day'
      if (reportType === 'VISITOR') {
        return `${prefix} Number of Users: `
      } else if (reportType === 'MENU') {
        return `${prefix} Number of Photo Seen: `
      } else if (reportType === 'DAY') {
        return `${prefix} Number of Days ON: `
      } else {
        return `${prefix} Number of Hours ON: `
      }
    },
    setNameChart(reportType) {
      if (reportType === 'VISITOR') {
        return 'Number of Users'
      } else if (reportType === 'MENU') {
        return 'Number of Photos Seen'
      } else if (reportType === 'DAY') {
        return 'Number of Days ON'
      } else {
        return 'Number of Hours ON'
      }
    }
  }
}
</script>
<style scoped>
.activeBtn {
  background: #f5c31d !important;
  border-color: #c8ced3 !important;
  font-weight: bold;
}
.deactiveBtn {
  background: #fff !important;
  border-color: #c8ced3 !important;
  color: #c8ced3 !important;
  font-weight: bold;
}
.tax-card {
  background: rgb(64, 0, 64) !important;
  color: #fff;
}
.tip-card {
  background: rgb(185, 122, 87) !important;
  color: #fff;
}
.restaurant-total-card {
  background: #66bb6a;
  color: #fff;
}
</style>
